<template>
    <div class="w-full">
        <!-- DESKTOP VERSION -->
        <div class="hidden md:flex w-full items-center">
            <div class="flex flex-col p-5 w-[55%]">
                <div class="flex flex-col rounded-xl bg-grey-lighter mb-5 px-8">
                    <article v-for="option in freeOptions" :key="option.title" class="flex items-center">
                        <div class="flex flex-col p-3 w-4/5">
                            <span class="text-green-darker font-bold text-xl text-start">{{option.title}}</span>
                            <span class="text-green-darker text-[13px] leading-6 text-start">{{option.description}}</span>
                        </div>
                        <div class="flex flex-1"></div>
                        <div class="flex items-center gap-3">
                            <span class="text-green-darkest text-sm">{{option.price}}</span>
                            <div class="flex-1"></div>
                            <div v-if="freeOptionsChecked" class="relative bg-green-darker rounded-full w-7 h-7">
                                <svg class="absolute top-[5px] left-1" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.563965 9.3777C0.647092 9.2467 0.650556 9.08964 0.699432 8.94698C1.27863 7.25206 3.33411 6.72337 4.61719 7.95996C5.31877 8.63637 5.98187 9.35399 6.66113 10.0541C6.70808 10.1027 6.74502 10.1614 6.78966 10.2197C8.02272 8.94931 9.23076 7.70456 10.4392 6.45981C12.0475 4.8026 13.6546 3.14462 15.2644 1.48935C16.2469 0.479012 17.6863 0.433141 18.6761 1.37662C19.6221 2.2785 19.699 3.84318 18.8258 4.8232C18.3905 5.31185 17.9226 5.77018 17.4669 6.24017C14.5086 9.28868 11.5491 12.336 8.59037 15.3842C7.54204 16.4641 6.08077 16.4719 5.03398 15.3962C3.79362 14.1223 2.5571 12.8441 1.31788 11.5687C0.97075 11.211 0.728295 10.7966 0.621692 10.3037C0.611686 10.2566 0.631313 10.1871 0.563965 10.1602L0.563965 9.3777Z" fill="white"/>
                                </svg>
                            </div>
                            <div v-else class="border-1/2 border-green-darkest rounded-full w-7 h-7"></div>
                        </div>
                    </article>
                </div>               
                <div class="flex flex-col rounded-xl bg-green-darker mb-5 px-8">
                    <article v-for="option in firstOptions" :key="option.title" class="flex items-center">
                        <div class="flex flex-col p-3 w-4/5">
                            <span class="text-yellow font-bold text-xl text-start">{{option.title}}</span>
                            <span class="text-white text-[13px] leading-6 text-start">{{option.description}}</span>
                        </div>
                        <div class="flex flex-1"></div>
                        <div class="flex items-center gap-3">
                            <span class="text-green-darkest text-sm">{{option.price}}</span>
                            <div class="flex-1"></div>
                            <div v-if="firstOptionsChecked" class="relative bg-white rounded-full w-7 h-7 fill-green-darker">
                                <svg class="absolute top-[5px] left-1" width="20" height="17" viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.563965 9.3777C0.647092 9.2467 0.650556 9.08964 0.699432 8.94698C1.27863 7.25206 3.33411 6.72337 4.61719 7.95996C5.31877 8.63637 5.98187 9.35399 6.66113 10.0541C6.70808 10.1027 6.74502 10.1614 6.78966 10.2197C8.02272 8.94931 9.23076 7.70456 10.4392 6.45981C12.0475 4.8026 13.6546 3.14462 15.2644 1.48935C16.2469 0.479012 17.6863 0.433141 18.6761 1.37662C19.6221 2.2785 19.699 3.84318 18.8258 4.8232C18.3905 5.31185 17.9226 5.77018 17.4669 6.24017C14.5086 9.28868 11.5491 12.336 8.59037 15.3842C7.54204 16.4641 6.08077 16.4719 5.03398 15.3962C3.79362 14.1223 2.5571 12.8441 1.31788 11.5687C0.97075 11.211 0.728295 10.7966 0.621692 10.3037C0.611686 10.2566 0.631313 10.1871 0.563965 10.1602L0.563965 9.3777Z"/>
                                </svg>
                            </div>
                            <div v-else class="border-1/2 border-white rounded-full w-7 h-7 cursor-pointer" @click="formula = 'first'"></div>
                        </div>
                    </article>
                </div>

            </div>
            <div class="flex flex-col p-4 w-[45%]">
                <div class="flex rounded-xl mb-5 p-3 pr-6 items-center cursor-pointer" :class="[formula == 'free' ? 'bg-grey-lighter' : 'bg-white border-1/2 border-green-darker']" @click="formula = 'free'">
                    <div class="px-5">
                        <div v-if="formula == 'free'" class="relative bg-green-darker rounded-full w-7 h-7">
                            <svg class="absolute top-[5px] left-1" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.563965 9.3777C0.647092 9.2467 0.650556 9.08964 0.699432 8.94698C1.27863 7.25206 3.33411 6.72337 4.61719 7.95996C5.31877 8.63637 5.98187 9.35399 6.66113 10.0541C6.70808 10.1027 6.74502 10.1614 6.78966 10.2197C8.02272 8.94931 9.23076 7.70456 10.4392 6.45981C12.0475 4.8026 13.6546 3.14462 15.2644 1.48935C16.2469 0.479012 17.6863 0.433141 18.6761 1.37662C19.6221 2.2785 19.699 3.84318 18.8258 4.8232C18.3905 5.31185 17.9226 5.77018 17.4669 6.24017C14.5086 9.28868 11.5491 12.336 8.59037 15.3842C7.54204 16.4641 6.08077 16.4719 5.03398 15.3962C3.79362 14.1223 2.5571 12.8441 1.31788 11.5687C0.97075 11.211 0.728295 10.7966 0.621692 10.3037C0.611686 10.2566 0.631313 10.1871 0.563965 10.1602L0.563965 9.3777Z" fill="white"/>
                            </svg>
                        </div>
                        <div v-else class="border-1/2 border-green-darkest rounded-full w-7 h-7"></div>
                    </div>
                    <div class="flex flex-col w-full">
                        <div class="flex flex-wrap">
                            <span class="font-bold text-green-darker text-2xl lg:text-[40px]">Standard</span>
                            <div class="flex-1"></div>
                            <span class="font-bold text-green-light text-2xl lg:text-[40px]">Gratuit</span>
                        </div>
                        <ul class="text-start text-[13px] text-green-darker leading-6">
                            <li>• Accès gratuit aux contacts des particuliers</li>
                            <li>• Aucune données bancaires demandées</li>
                        </ul>

                    </div>
                </div>                
                <div class="flex rounded-xl mb-5 p-3 pr-6 items-center cursor-pointer" :class="[formula == 'first' ? 'bg-green-darker' : 'bg-white border-1/2 border-green-darker']" @click="formula = 'first'">
                    <div class="px-5">
                        <div v-if="formula == 'first'" class="relative bg-white rounded-full w-7 h-7 fill-green-darker">
                            <svg class="absolute top-[5px] left-1" width="20" height="17" viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.563965 9.3777C0.647092 9.2467 0.650556 9.08964 0.699432 8.94698C1.27863 7.25206 3.33411 6.72337 4.61719 7.95996C5.31877 8.63637 5.98187 9.35399 6.66113 10.0541C6.70808 10.1027 6.74502 10.1614 6.78966 10.2197C8.02272 8.94931 9.23076 7.70456 10.4392 6.45981C12.0475 4.8026 13.6546 3.14462 15.2644 1.48935C16.2469 0.479012 17.6863 0.433141 18.6761 1.37662C19.6221 2.2785 19.699 3.84318 18.8258 4.8232C18.3905 5.31185 17.9226 5.77018 17.4669 6.24017C14.5086 9.28868 11.5491 12.336 8.59037 15.3842C7.54204 16.4641 6.08077 16.4719 5.03398 15.3962C3.79362 14.1223 2.5571 12.8441 1.31788 11.5687C0.97075 11.211 0.728295 10.7966 0.621692 10.3037C0.611686 10.2566 0.631313 10.1871 0.563965 10.1602L0.563965 9.3777Z"/>
                            </svg>
                        </div>
                        <div v-else class="border-1/2 border-green-darkest rounded-full w-7 h-7"></div>
                    </div>
                    <div class="flex flex-col w-full">
                        <div class="flex items-center gap-1 flex-wrap">
                            <span class="font-bold  text-2xl lg:text-[40px]" :class="[formula == 'first' ? 'text-white' : 'text-green-darker']">First</span>
                            <div class="flex-1"></div>
                            <span class="font-bold text-2xl lg:text-[40px]" :class="[formula == 'first' ? 'text-yellow' : 'text-green-light']">89€</span>
                            <span class="text-sm" :class="[formula == 'first' ? 'text-yellow' : 'text-black']">/mois</span>
                        </div>
                        <ul class="text-start text-[13px] text-green-darker leading-6" :class="[formula == 'first' ? 'text-white' : 'text-green-darker']">
                            <li>• Abonnement mensuel sans engagement, prix HT</li>
                            <li>• Réservé aux 3 premiers pros souscripteurs par <span class="font-bold text-red" :class="[formula == 'first' ? 'text-yellow' : 'text-red']">code postal</span></li>                            
                        </ul>

                    </div>
                </div>                
                <span class="text-xs mb-3 text-green-darker font-semibold">Taux personnalisé indiqué dans votre compte professionnel rubrique / mon contrat</span>
                <button v-if="!authenticated || (formula === 'first' && !first || formula === 'mandat' && !mandat && !first)" class="flex items-center gap-2 justify-center bg-yellow text-green-darkest font-bold lg:text-[22px] rounded-full p-3 h-[52px]" @click="choose(null)">
                    Choisir cette formule
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 13.6L13.6 10M13.6 10L10 6.4M13.6 10H6.4M19 10C19 14.9705 14.9705 19 10 19C5.02943 19 1 14.9705 1 10C1 5.02943 5.02943 1 10 1C14.9705 1 19 5.02943 19 10Z" stroke="#1A2E35" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
        <!-- DESKTOP VERSION -->

        <div class="grid grid-cols-7 gap-2 items-center mb-4 md:hidden">
          <div class="col-span-2"></div>
          <div class="flex col-span-3">
            <div class="w-20 h-2 rounded-md cursor-pointer" :class="[activeSwiperSlideIndex == 0 ? 'bg-green-darker' : 'bg-grey-lighter']" @click="swipeTo(0)"></div>
            <div class="w-20 h-2 rounded-md cursor-pointer" :class="[activeSwiperSlideIndex == 1 ? 'bg-green-darker' : 'bg-grey-lighter']" @click="swipeTo(1)"></div>            
          </div>
          <button @click="swipeNext()">
            <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 13.6L13.6 10M13.6 10L10 6.4M13.6 10H6.4M19 10C19 14.9705 14.9705 19 10 19C5.02943 19 1 14.9705 1 10C1 5.02943 5.02943 1 10 1C14.9705 1 19 5.02943 19 10Z" stroke="#144B54" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </button>
        </div>
        <!-- MOBILE VERSION -->
        <div class="swiper md:hidden">

            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">

              <!-- Slide 1 -->
              <div class="swiper-slide flex flex-col gap-3">
                <div class="flex flex-col bg-grey-lighter rounded-xl py-3 px-5">
                    <div class="flex mb-2">
                        <span class="font-bold text-green-darker text-xl">Standard</span>
                        <div class="flex-1"></div>
                        <span class="font-bold text-green-light text-xl">Gratuit</span>
                    </div>
                    <ul class="text-start text-xs text-green-darker leading-6">
                        <li>• Accès gratuit aux contacts des particuliers</li>
                        <li>• Aucune données bancaires demandées</li>
                    </ul>
                </div>
                <div class="flex flex-col bg-grey-lighter rounded-xl py-3 px-5 gap-3">
                    <div v-for="option in freeOptions" :key="option.title" class="flex items-center gap-3">
                        <div>
                            <div class="relative bg-green-darker rounded-full w-3.5 h-3.5">
                                <svg class="absolute top-[2px] left-[2px] w-2.5 h-2.5" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.563965 9.3777C0.647092 9.2467 0.650556 9.08964 0.699432 8.94698C1.27863 7.25206 3.33411 6.72337 4.61719 7.95996C5.31877 8.63637 5.98187 9.35399 6.66113 10.0541C6.70808 10.1027 6.74502 10.1614 6.78966 10.2197C8.02272 8.94931 9.23076 7.70456 10.4392 6.45981C12.0475 4.8026 13.6546 3.14462 15.2644 1.48935C16.2469 0.479012 17.6863 0.433141 18.6761 1.37662C19.6221 2.2785 19.699 3.84318 18.8258 4.8232C18.3905 5.31185 17.9226 5.77018 17.4669 6.24017C14.5086 9.28868 11.5491 12.336 8.59037 15.3842C7.54204 16.4641 6.08077 16.4719 5.03398 15.3962C3.79362 14.1223 2.5571 12.8441 1.31788 11.5687C0.97075 11.211 0.728295 10.7966 0.621692 10.3037C0.611686 10.2566 0.631313 10.1871 0.563965 10.1602L0.563965 9.3777Z" fill="white"/>
                                </svg>
                            </div>
                        </div>
                        <div class="flex flex-col">
                            <span class="text-green-darker font-bold text-base text-start">{{option.title}}</span>
                            <span class="text-green-darker text-xs leading-6 text-start">{{option.description}}</span>
                        </div>

                    </div>
                </div>
                <button v-if="!authenticated" class="flex items-center gap-2 justify-center bg-yellow text-green-darker font-bold rounded-full p-3 h-12" @click="choose('free')">
                    Choisir cette formule
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 13.6L13.6 10M13.6 10L10 6.4M13.6 10H6.4M19 10C19 14.9705 14.9705 19 10 19C5.02943 19 1 14.9705 1 10C1 5.02943 5.02943 1 10 1C14.9705 1 19 5.02943 19 10Z" stroke="#144B54" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
              </div>              
              <!-- Slide 3 -->
              <div class="swiper-slide flex flex-col">
                <div class="flex flex-col bg-green-darker rounded-xl py-3 px-5">
                    <div class="flex mb-2 items-center">
                        <span class="font-bold text-white text-xl">First</span>
                        <div class="flex-1"></div>
                        <span class="font-bold text-yellow text-xl">89€</span>
                        <span class="font-bold text-yellow text-xs">/mois</span>
                    </div>
                    <ul class="text-start text-xs text-white leading-6">
                        <li>• Abonnement mensuel sans engagement, prix HT</li>
                        <li>• Réservé aux 3 premiers pros souscripteurs par <span class="font-bold text-yellow">code postal</span></li>                        
                    </ul>
                </div>
                <span class="text-3xl text-center">=</span>
                <div class="flex flex-col bg-grey-lighter rounded-xl py-3 px-5">
                    <div class="flex mb-2">
                        <span class="font-bold text-green-darker text-xl">Standard</span>
                        <div class="flex-1"></div>
                        <span class="font-bold text-green-light text-xl">Gratuit</span>
                    </div>
                    <ul class="text-start text-xs text-green-darker leading-6">
                        <li>• Accès gratuit aux contacts des particuliers</li>
                        <li>• Aucune données bancaires demandées</li>
                    </ul>
                </div>                
                <span class="text-3xl text-center">+</span>
                <div class="flex flex-col bg-green-darker rounded-xl py-3 px-5 gap-3">
                    <div v-for="option in firstOptions" :key="option.title" class="flex items-center gap-3">
                        <div>
                            <div class="relative bg-white rounded-full w-3.5 h-3.5">
                                <svg class="absolute top-[2px] left-[2px] w-2.5 h-2.5 fill-green-darker" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.563965 9.3777C0.647092 9.2467 0.650556 9.08964 0.699432 8.94698C1.27863 7.25206 3.33411 6.72337 4.61719 7.95996C5.31877 8.63637 5.98187 9.35399 6.66113 10.0541C6.70808 10.1027 6.74502 10.1614 6.78966 10.2197C8.02272 8.94931 9.23076 7.70456 10.4392 6.45981C12.0475 4.8026 13.6546 3.14462 15.2644 1.48935C16.2469 0.479012 17.6863 0.433141 18.6761 1.37662C19.6221 2.2785 19.699 3.84318 18.8258 4.8232C18.3905 5.31185 17.9226 5.77018 17.4669 6.24017C14.5086 9.28868 11.5491 12.336 8.59037 15.3842C7.54204 16.4641 6.08077 16.4719 5.03398 15.3962C3.79362 14.1223 2.5571 12.8441 1.31788 11.5687C0.97075 11.211 0.728295 10.7966 0.621692 10.3037C0.611686 10.2566 0.631313 10.1871 0.563965 10.1602L0.563965 9.3777Z"/>
                                </svg>
                            </div>
                        </div>
                        <div class="flex flex-col">
                            <span class="text-yellow font-bold text-base text-start">{{option.title}}</span>
                            <span class="text-white text-xs leading-6 text-start">{{option.description}}</span>
                        </div>

                    </div>
                </div>                
                <span class="text-xs mb-3 text-green-darker font-semibold">Taux personnalisé indiqué dans votre compte professionnel rubrique / mon contrat</span>
                <button v-if="!first" class="flex items-center gap-2 justify-center bg-yellow text-green-darker font-bold rounded-full p-3 h-12 mt-3" @click="choose('first')">
                    Choisir cette formule
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 13.6L13.6 10M13.6 10L10 6.4M13.6 10H6.4M19 10C19 14.9705 14.9705 19 10 19C5.02943 19 1 14.9705 1 10C1 5.02943 5.02943 1 10 1C14.9705 1 19 5.02943 19 10Z" stroke="#144B54" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
              </div>
            </div>
        </div>
        <!-- MOBILE VERSION -->
    </div>

</template>

<script>
    import Swiper from 'swiper';

    export default {
        name: "pricing-table-pro",
        data() {
            return {
                freeOptions :  [
                    {
                        title: "Réception des projets clients",
                        description: "Projets de vente, d'achat et/ou de location.",
                        price: "Gratuit",
                    },
                    {
                        title: "Accès aux coordonnées des particuliers",
                        description: "Affichez le numéro de téléphone, l'adresse mail et bien plus.",
                        price: "Gratuit",
                    },
                    {
                        title: "10 codes postaux à définir",
                        description: "Définissez votre secteur géographique d'activité.",
                        price: "Gratuit",
                    }
                ],
                firstOptions : [
                    {
                        title: "Projets clients reçus 72h avant les autres agents",
                        description: "Vous êtes prioritaires et accédez aux coordonnées clients 72H avant tous les autres agents (acquéreurs, vendeurs) non First. ",
                        price: "",
                    },
                    {
                        title: "Exclusivité en cas de rendez-vous mandats",
                        description: "Les rendez-vous mandats dans votre secteur sont réservés aux professionnels  First. Aucun autre professionnel ne recevra de rendez-vous si un agent First est disponible dans la zone.",
                        price: "",
                    },
                ],
                formula: this.first ? 'first' : 'free',
                mySwiper: null
            }
        },
        props: {
            first: {
                type: Boolean,
                default: 'false'
            },
            mandat: {
                type: Boolean,
                default: 'false'
            },
            authenticated: {
                type: Boolean,
                default: 'false'
            }

        },
        computed: {
            freeOptionsChecked() {
                return true;
            },            
            firstOptionsChecked() {
                return this.formula === 'first';
            },
            swiperInstance() {
                return this.mySwiper instanceof Array ? this.mySwiper[1] : this.mySwiper;
            },
            activeSwiperSlideIndex() {
              return this.swiperInstance ? this.swiperInstance.activeIndex : 0;
            }
        },
        methods: {
            choose(formula) {
                if (formula === null) {
                    window.location.replace('/abonnement/' + this.formula);
                } else {
                    window.location.replace('/abonnement/' + formula);
                }
            },
            swipeNext() {
                this.swiperInstance.slideNext();
            },
            swipeTo(index) {
              this.swiperInstance.slideTo(index);
            }
        },
        mounted() {
            this.mySwiper = new Swiper('.swiper', {
                slidesPerView: 1,
                initialSlide: this.first ? 1 : 0,
                //ne pas supprimer ci-dessous : permet de faire fonctionner le swiper testimonials de la Homepage Pro (les 2 confs swiper JS & Vue interfèrent)
                breakpoints: {
                  640: {
                    slidesPerView: 1
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  }                  
                },
            });
        }

    }
</script>
<style scoped>
/*
! tailwindcss v3.4.6 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured `sans` font-family by default.
5. Use the user's configured `sans` font-feature-settings by default.
6. Use the user's configured `sans` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -moz-tab-size: 4;
  /* 3 */
  tab-size: 4;
  /* 3 */
  font-family: Inter;
  /* 4 */
  font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
  -webkit-tap-highlight-color: transparent;
  /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.
*/
body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured `mono` font-family by default.
2. Use the user's configured `mono` font-feature-settings by default.
3. Use the user's configured `mono` font-variation-settings by default.
4. Correct the odd `em` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-feature-settings: normal;
  /* 2 */
  font-variation-settings: normal;
  /* 3 */
  font-size: 1em;
  /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent `sub` and `sup` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  letter-spacing: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to `inherit` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  --tw-contain-size: ;
  --tw-contain-layout: ;
  --tw-contain-paint: ;
  --tw-contain-style: ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  --tw-contain-size: ;
  --tw-contain-layout: ;
  --tw-contain-paint: ;
  --tw-contain-style: ;
}
.absolute {
  position: absolute!important;
}
.relative {
  position: relative!important;
}
.left-1 {
  left: 0.25rem!important;
}
.left-\[2px\] {
  left: 2px!important;
}
.top-\[2px\] {
  top: 2px!important;
}
.top-\[5px\] {
  top: 5px!important;
}
.col-span-2 {
  grid-column: span 2 / span 2!important;
}
.col-span-3 {
  grid-column: span 3 / span 3!important;
}
.mb-2 {
  margin-bottom: 0.5rem!important;
}
.mb-3 {
  margin-bottom: 0.75rem!important;
}
.mb-4 {
  margin-bottom: 1rem!important;
}
.mb-5 {
  margin-bottom: 1.25rem!important;
}
.mt-2 {
  margin-top: 0.5rem!important;
}
.mt-3 {
  margin-top: 0.75rem!important;
}
.flex {
  display: flex!important;
}
.grid {
  display: grid!important;
}
.hidden {
  display: none!important;
}
.h-12 {
  height: 3rem!important;
}
.h-2 {
  height: 0.5rem!important;
}
.h-2\.5 {
  height: 0.625rem!important;
}
.h-3\.5 {
  height: 0.875rem!important;
}
.h-7 {
  height: 1.75rem!important;
}
.h-\[52px\] {
  height: 52px!important;
}
.w-2\.5 {
  width: 0.625rem!important;
}
.w-20 {
  width: 5rem!important;
}
.w-3\.5 {
  width: 0.875rem!important;
}
.w-4\/5 {
  width: 80%!important;
}
.w-7 {
  width: 1.75rem!important;
}
.w-\[45\%\] {
  width: 45%!important;
}
.w-\[55\%\] {
  width: 55%!important;
}
.w-full {
  width: 100%!important;
}
.flex-1 {
  flex: 1 1 0%!important;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))!important;
}
.cursor-pointer {
  cursor: pointer!important;
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr))!important;
}
.flex-col {
  flex-direction: column!important;
}
.flex-wrap {
  flex-wrap: wrap!important;
}
.items-center {
  align-items: center!important;
}
.justify-center {
  justify-content: center!important;
}
.gap-1 {
  gap: 0.25rem!important;
}
.gap-2 {
  gap: 0.5rem!important;
}
.gap-3 {
  gap: 0.75rem!important;
}
.rounded-full {
  border-radius: 9999px!important;
}
.rounded-md {
  border-radius: 0.375rem!important;
}
.rounded-xl {
  border-radius: 0.75rem!important;
}
.border-1\/2 {
  border-width: 0.5px!important;
}
.border-green-darker {
  --tw-border-opacity: 1!important;
  border-color: rgb(20 75 84 / var(--tw-border-opacity))!important;
}
.border-green-darkest {
  --tw-border-opacity: 1!important;
  border-color: rgb(26 46 53 / var(--tw-border-opacity))!important;
}
.border-white {
  --tw-border-opacity: 1!important;
  border-color: rgb(253 253 253 / var(--tw-border-opacity))!important;
}
.bg-blue-dark {
  --tw-bg-opacity: 1!important;
  background-color: rgb(97 148 155 / var(--tw-bg-opacity))!important;
}
.bg-green-darker {
  --tw-bg-opacity: 1!important;
  background-color: rgb(20 75 84 / var(--tw-bg-opacity))!important;
}
.bg-grey-lighter {
  --tw-bg-opacity: 1!important;
  background-color: rgb(239 246 248 / var(--tw-bg-opacity))!important;
}
.bg-white {
  --tw-bg-opacity: 1!important;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity))!important;
}
.bg-yellow {
  --tw-bg-opacity: 1!important;
  background-color: rgb(255 224 60 / var(--tw-bg-opacity))!important;
}
.fill-green-darker {
  fill: #144B54!important;
}
.p-3 {
  padding: 0.75rem!important;
}
.p-4 {
  padding: 1rem!important;
}
.p-5 {
  padding: 1.25rem!important;
}
.px-5 {
  padding-left: 1.25rem!important;
  padding-right: 1.25rem!important;
}
.px-8 {
  padding-left: 2rem!important;
  padding-right: 2rem!important;
}
.py-3 {
  padding-top: 0.75rem!important;
  padding-bottom: 0.75rem!important;
}
.pr-6 {
  padding-right: 1.5rem!important;
}
.text-center {
  text-align: center!important;
}
.text-start {
  text-align: start!important;
}
.text-2xl {
  font-size: 26px!important;
}
.text-3xl {
  font-size: 34px!important;
}
.text-\[13px\] {
  font-size: 13px!important;
}
.text-\[22px\] {
  font-size: 22px!important;
}
.text-\[40px\] {
  font-size: 40px!important;
}
.text-base {
  font-size: 16px!important;
}
.text-sm {
  font-size: 14px!important;
}
.text-xl {
  font-size: 20px!important;
}
.text-xs {
  font-size: 12px!important;
}
.font-bold {
  font-weight: 700!important;
}
.font-semibold {
  font-weight: 600!important;
}
.leading-6 {
  line-height: 1.5rem!important;
}
.text-black {
  --tw-text-opacity: 1!important;
  color: rgb(0 0 0 / var(--tw-text-opacity))!important;
}
.text-green-darker {
  --tw-text-opacity: 1!important;
  color: rgb(20 75 84 / var(--tw-text-opacity))!important;
}
.text-green-darkest {
  --tw-text-opacity: 1!important;
  color: rgb(26 46 53 / var(--tw-text-opacity))!important;
}
.text-green-light {
  --tw-text-opacity: 1!important;
  color: rgb(128 207 194 / var(--tw-text-opacity))!important;
}
.text-red {
  --tw-text-opacity: 1!important;
  color: rgb(208 42 23 / var(--tw-text-opacity))!important;
}
.text-white {
  --tw-text-opacity: 1!important;
  color: rgb(253 253 253 / var(--tw-text-opacity))!important;
}
.text-yellow {
  --tw-text-opacity: 1!important;
  color: rgb(255 224 60 / var(--tw-text-opacity))!important;
}
@media (min-width: 768px) {
  .md\:flex {
    display: flex!important;
  }
  .md\:hidden {
    display: none!important;
  }
}
@media (min-width: 1024px) {
  .lg\:text-\[22px\] {
    font-size: 22px!important;
  }
  .lg\:text-\[40px\] {
    font-size: 40px!important;
  }
}








/**
 * Swiper 11.1.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: May 30, 2024
 */

/* FONT_START */
@font-face {
    font-family: 'swiper-icons';
    src: url('data:application/font-woff;charset=utf-8;base64, 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');
    font-weight: 400;
    font-style: normal;
  }
  /* FONT_END */
  :root {
    --swiper-theme-color: #007aff;
    /*
    --swiper-preloader-color: var(--swiper-theme-color);
    --swiper-wrapper-transition-timing-function: initial;
    */
  }
  :host {
    position: relative;
    display: block;
    margin-left: auto;
    margin-right: auto;
    z-index: 1;
  }
  .swiper {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    /* Fix of Webkit flickering */
    z-index: 1;
    display: block;
  }
  .swiper-vertical > .swiper-wrapper {
    flex-direction: column;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);
    box-sizing: content-box;
  }
  .swiper-android .swiper-slide,
  .swiper-ios .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }
  .swiper-horizontal {
    touch-action: pan-y;
  }
  .swiper-vertical {
    touch-action: pan-x;
  }
  .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: transform;
    display: block;
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
  /* Auto Height */
  .swiper-autoheight,
  .swiper-autoheight .swiper-slide {
    height: auto;
  }
  .swiper-autoheight .swiper-wrapper {
    align-items: flex-start;
    transition-property: transform, height;
  }
  .swiper-backface-hidden .swiper-slide {
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
  }
  /* 3D Effects */
  .swiper-3d.swiper-css-mode .swiper-wrapper {
    perspective: 1200px;
  }
  .swiper-3d .swiper-wrapper {
    transform-style: preserve-3d;
  }
  .swiper-3d {
    perspective: 1200px;
  }
  .swiper-3d .swiper-slide,
  .swiper-3d .swiper-cube-shadow {
    transform-style: preserve-3d;
  }
  /* CSS Mode */
  .swiper-css-mode > .swiper-wrapper {
    overflow: auto;
    scrollbar-width: none;
    /* For Firefox */
    -ms-overflow-style: none;
    /* For Internet Explorer and Edge */
  }
  .swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {
    display: none;
  }
  .swiper-css-mode > .swiper-wrapper > .swiper-slide {
    scroll-snap-align: start start;
  }
  .swiper-css-mode.swiper-horizontal > .swiper-wrapper {
    scroll-snap-type: x mandatory;
  }
  .swiper-css-mode.swiper-vertical > .swiper-wrapper {
    scroll-snap-type: y mandatory;
  }
  .swiper-css-mode.swiper-free-mode > .swiper-wrapper {
    scroll-snap-type: none;
  }
  .swiper-css-mode.swiper-free-mode > .swiper-wrapper > .swiper-slide {
    scroll-snap-align: none;
  }
  .swiper-css-mode.swiper-centered > .swiper-wrapper::before {
    content: '';
    flex-shrink: 0;
    order: 9999;
  }
  .swiper-css-mode.swiper-centered > .swiper-wrapper > .swiper-slide {
    scroll-snap-align: center center;
    scroll-snap-stop: always;
  }
  .swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {
    margin-inline-start: var(--swiper-centered-offset-before);
  }
  .swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper::before {
    height: 100%;
    min-height: 1px;
    width: var(--swiper-centered-offset-after);
  }
  .swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {
    margin-block-start: var(--swiper-centered-offset-before);
  }
  .swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper::before {
    width: 100%;
    min-width: 1px;
    height: var(--swiper-centered-offset-after);
  }
  /* Slide styles start */
  /* 3D Shadows */
  .swiper-3d .swiper-slide-shadow,
  .swiper-3d .swiper-slide-shadow-left,
  .swiper-3d .swiper-slide-shadow-right,
  .swiper-3d .swiper-slide-shadow-top,
  .swiper-3d .swiper-slide-shadow-bottom,
  .swiper-3d .swiper-slide-shadow,
  .swiper-3d .swiper-slide-shadow-left,
  .swiper-3d .swiper-slide-shadow-right,
  .swiper-3d .swiper-slide-shadow-top,
  .swiper-3d .swiper-slide-shadow-bottom {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
  }
  .swiper-3d .swiper-slide-shadow {
    background: rgba(0, 0, 0, 0.15);
  }
  .swiper-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }
  .swiper-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }
  .swiper-3d .swiper-slide-shadow-top {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }
  .swiper-3d .swiper-slide-shadow-bottom {
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }
  .swiper-lazy-preloader {
    width: 42px;
    height: 42px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -21px;
    margin-top: -21px;
    z-index: 10;
    transform-origin: 50%;
    box-sizing: border-box;
    border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
    border-radius: 50%;
    border-top-color: transparent;
  }
  .swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,
  .swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader {
    animation: swiper-preloader-spin 1s infinite linear;
  }
  .swiper-lazy-preloader-white {
    --swiper-preloader-color: #fff;
  }
  .swiper-lazy-preloader-black {
    --swiper-preloader-color: #000;
  }
  @keyframes swiper-preloader-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  /* Slide styles end */



</style>




// WEBPACK FOOTER //
// application/assets/js/professional/components/PricingTable/pricing-table.vue